import type { ReferentialPeriodType } from '../types/referentialPeriod.type';

export const REFERENTIAL_PERIOD: ReferentialPeriodType = {
  carrefour: {
    availablePeriod: {
      periods: ['daily', 'weekly', 'monthly'],
      unavailableMessage: 'availableOnNielsen'
    }
  },
  nielsen: {
    availablePeriod: {
      periods: ['weekly', 'nielsen'],
      unavailableMessage: 'availableOnCarrefour'
    }
  }
};
